export function getRegionFromUrl(url = '') {
  return url.replace(/\//g, '');
}
